<script lang="ts" setup>
import type { FuseResultMatch } from 'fuse.js';

import { computed } from 'vue';
import { getTextPartsWithHighlights } from '#layers/ui/utils/search';

const {
	searchMatches,
	searchMatchKey,
	value,
} = defineProps<{
	value: string;
	searchMatches: ReadonlyArray<FuseResultMatch> | undefined;
	searchMatchKey: string;
}>();

const indices = computed(() => (searchMatches?.filter((m) => m.key === searchMatchKey) ?? []).flatMap((m) => m.indices));
const parts = computed(() => getTextPartsWithHighlights(value, indices.value));
</script>

<template>
	<template v-if="indices.length > 0">
		<span
			v-for="(part, index) in parts"
			:key="index"
			:class="part.highlight ? 'rounded-sm bg-primary/20 text-primary-800 dark:text-primary-200' : ''"
		>
			{{ part.text }}
		</span>
	</template>
	<slot v-else>
		{{ value }}
	</slot>
</template>
